interface Configuration {
    navigationType: 'history',
    useSampleData?: boolean,
    api: {
        baseUrl: string
    },
    notification: {
        baseUrl: string
    }
}

const configuration: Configuration = {
    navigationType: 'history',
    useSampleData: true,
    api: {
        baseUrl: (process.env.NODE_ENV !== 'production') ? 'https://localhost:44360/' : ''
    },
    notification: {
        baseUrl: 'http://localhost:5000/api'
    }
}

export default configuration